import { Outlet, Link, useLocation } from "react-router-dom";
import { useAuthStore } from "../store/authStore";

export default function AdminLayout() {
  const { user, clearAuth } = useAuthStore();
  const location = useLocation();

  const handleLogout = () => {
    clearAuth();
    window.location.href = "/login";
  };

  const menuItems = [
    { path: "/admin", label: "Dashboard", icon: "🏠" },
    { path: "/admin/users", label: "Users", icon: "👥" },
    { path: "/admin/surveys", label: "Surveys", icon: "📋" },
    { path: "/admin/transactions", label: "Transactions", icon: "💰" },
    { path: "/admin/redemptions", label: "Redemptions", icon: "🎁" },
    { path: "/admin/fees", label: "Fee Summary", icon: "📊" },
  ];

  return (
    <div className="min-h-screen bg-dark-900">
      {/* Header */}
      <header className="bg-dark-800 border-b border-dark-border sticky top-0 z-50">
        <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-8">
              <Link to="/admin" className="text-2xl font-bold text-primary-400 flex items-center gap-2">
                <span>🦞</span>
                <span>Clawplete Admin</span>
              </Link>
              <span className="px-3 py-1 bg-primary-500/20 text-primary-400 rounded-full text-sm font-medium">
                Admin Panel
              </span>
            </div>
            <div className="flex items-center gap-6">
              <Link to="/dashboard" className="nav-link">
                Back to App
              </Link>
              <button
                onClick={handleLogout}
                className="px-4 py-2 text-sm font-medium text-gray-400 hover:text-white transition-colors"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content Area */}
      <div className="flex h-[calc(100vh-73px)]">
        {/* Sidebar - Fixed height, no scroll */}
        <aside className="w-64 bg-dark-800 border-r border-dark-border flex flex-col h-full">
          <nav className="p-4 space-y-2 flex-1 overflow-y-auto">
            {menuItems.map((item) => {
              const isActive = location.pathname === item.path ||
                               (item.path !== "/admin" && location.pathname.startsWith(item.path));
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                    isActive
                      ? "bg-primary-500/20 text-primary-400 font-medium"
                      : "text-gray-400 hover:bg-dark-700 hover:text-white"
                  }`}
                >
                  <span className="text-xl">{item.icon}</span>
                  <span>{item.label}</span>
                </Link>
              );
            })}
          </nav>

          {/* Admin Info - Always visible at bottom */}
          <div className="p-4 border-t border-dark-border bg-dark-800 flex-shrink-0">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-primary-500/20 flex items-center justify-center">
                <span className="text-lg">👤</span>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-white truncate">
                  {user?.email}
                </p>
                <p className="text-xs text-gray-400">Administrator</p>
              </div>
            </div>
          </div>
        </aside>

        {/* Content Area */}
        <main className="flex-1 p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
